import React from 'react';
import { Link } from 'react-router-dom';
import { X, BookmarkIcon, HomeIcon, SearchIcon, TagIcon, InfoIcon, HelpCircleIcon, LayoutDashboardIcon } from 'lucide-react';
interface MobileMenuProps {
  onClose: () => void;
  savedCount: number;
  onSavedClick: () => void;
  onDashboardClick: () => void;
}
export function MobileMenu({
  onClose,
  savedCount,
  onSavedClick,
  onDashboardClick
}: MobileMenuProps) {
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 md:hidden" data-id="element-249">
      <div className="bg-white h-full w-4/5 max-w-xs flex flex-col animate-slide-in" data-id="element-250">
        <div className="p-4 border-b border-gray-200 flex items-center justify-between" data-id="element-251">
          <div className="font-bold text-2xl" data-id="element-252">
            <span data-id="element-253">KODI</span>
            <span className="text-yellow-400" data-id="element-254">F</span>
          </div>
          <button className="p-1 rounded-full hover:bg-gray-100" onClick={onClose} data-id="element-255">
            <X size={24} className="text-black" data-id="element-256" />
          </button>
        </div>
        <div className="p-4" data-id="element-257">
          <div className="relative mb-4" data-id="element-258">
            <input type="text" placeholder="Search for coupons..." className="w-full py-2 px-4 pr-10 rounded-full bg-gray-100 focus:outline-none focus:ring-2 focus:ring-green-500" data-id="element-259" />
            <SearchIcon className="absolute right-3 top-2.5 text-black" size={18} data-id="element-260" />
          </div>
          <nav className="space-y-1" data-id="element-261">
            <Link to="/" className="flex items-center p-3 rounded-lg hover:bg-gray-100" onClick={onClose} data-id="element-262">
              <HomeIcon size={20} className="mr-3 text-black" data-id="element-263" />
              <span data-id="element-264">Home</span>
            </Link>
            <Link to="/about" className="flex items-center p-3 rounded-lg hover:bg-gray-100" onClick={onClose} data-id="element-265">
              <InfoIcon size={20} className="mr-3 text-black" data-id="element-266" />
              <span data-id="element-267">About Us</span>
            </Link>
            <button className="flex items-center w-full p-3 rounded-lg hover:bg-gray-100 text-left" onClick={onDashboardClick} data-id="element-268">
              <LayoutDashboardIcon size={20} className="mr-3 text-black" data-id="element-269" />
              <span data-id="element-270">Dashboard</span>
            </button>
            <button className="flex items-center w-full p-3 rounded-lg hover:bg-gray-100 text-left relative" onClick={onSavedClick} data-id="element-271">
              <BookmarkIcon size={20} className="mr-3 text-black" data-id="element-272" />
              <span data-id="element-273">Saved Coupons</span>
              {savedCount > 0 && <span className="ml-2 bg-green-500 text-white text-xs rounded-full px-2 py-0.5" data-id="element-274">
                  {savedCount}
                </span>}
            </button>
            <a href="#" className="flex items-center p-3 rounded-lg hover:bg-gray-100" data-id="element-275">
              <TagIcon size={20} className="mr-3 text-black" data-id="element-276" />
              <span data-id="element-277">All Coupons</span>
            </a>
            <a href="#" className="flex items-center p-3 rounded-lg hover:bg-gray-100" data-id="element-278">
              <HelpCircleIcon size={20} className="mr-3 text-black" data-id="element-279" />
              <span data-id="element-280">Help & Support</span>
            </a>
          </nav>
        </div>
        <div className="mt-auto p-4 border-t border-gray-200 text-sm text-gray-500" data-id="element-281">
          <p data-id="element-282">© 2023. All rights reserved KODIF</p>
        </div>
      </div>
    </div>;
}